import XTbl,{Xtc} from '../../components/x-table/index';
const tbl = new XTbl('/task/query/', 'task list');

tbl.add(new Xtc('due_date', 'Due date').renderSlot('due_date'))
tbl.add(new Xtc('title', 'Task').renderSlot('title'))
tbl.add(new Xtc('status', 'Status').renderSlot('status'))
tbl.add(new Xtc('priority', 'Priority').renderSlot('priority'))
tbl.add(new Xtc('time_estimate', 'Time estimate').renderSlot('time').hidden())
tbl.add(new Xtc('matter.title', 'Matter').renderSlot('matter'))
tbl.add(new Xtc('assigned_contact.fullname', 'Contact').hidden().renderSlot('contact'))
tbl.add(new Xtc('task_type.title', 'Task type').hidden().renderSlot('task_type'))
tbl.add(new Xtc('assigned_user.fullname', 'Assigned').renderSlot('assigned'))

export default tbl;
